import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-signature-complete',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="signature-complete">
      <div class="content">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h1>Thank You!</h1>
        <p>
          Thank you for digitally signing the Letter of Authority.
        </p>
        <p class="instruction">
          You can now close this tab to return to the Consent Wallet.
        </p>
      </div>
    </div>
  `,
  styles: [`
    .signature-complete {
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f5f5;
    }

    .content {
      text-align: center;
      max-width: 480px;
      padding: 48px 32px;
      background: white;
      border-radius: 12px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    }

    .success-icon {
      font-size: 64px;
      width: 64px;
      height: 64px;
      color: #4caf50;
    }

    h1 {
      margin: 16px 0 8px;
      color: #333;
      font-size: 24px;
    }

    p {
      margin: 0 0 8px;
      color: #666;
      font-size: 16px;
      line-height: 1.5;
    }

    .instruction {
      margin-top: 16px;
      font-weight: 500;
      color: #333;
    }
  `]
})
export class SignatureCompleteComponent {}
